var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeMobile3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 186 149",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.3004 103.897C15.0307 157.539 42.2365 151.54 81.5069 141.807C100.608 135.535 123.944 127.361 173.899 70.9723C236.344 0.486176 37.2556 -21.8462 8.85335 24.9846C-19.5489 71.8154 37.2261 51.8919 26.3004 103.897Z",
  fill: "current"
})));
export default SvgShapeMobile3;